import React, { useEffect } from 'react'
import { useToken } from 'app/hooks'
import { useNavigate } from 'react-router-dom'
import API from '../../../utils/api'

export const LogoutPage = () => {
	const { data: token, mutate } = useToken('', false)
	const navigate = useNavigate()

	useEffect(() => {
		mutate(null)
		navigate('/admin/login')
	}, [])

	return null
}
